import type { TransactionRule } from '@carboncopyco/types';
import { useCallback, useReducer } from 'react';
import { EditTransactionRuleStep } from './types';

enum WizardActionType {
  GoToStep = 0,
}

export interface WizardState {
  step: EditTransactionRuleStep;
  transactionRule: TransactionRule;
}

interface WizardAction {
  type: WizardActionType;
  payload?: any;
}

const editTransactionRuleReducer = (
  state: WizardState,
  action: WizardAction
) => {
  const { type, payload } = action;
  switch (type) {
    case WizardActionType.GoToStep: {
      return { ...state, step: payload };
    }
    default: {
      throw Error(`Unknown action: ${type}`);
    }
  }
};

const initialIndex = 0;
const initialState = {
  step: EditTransactionRuleStep.EditGeneralSettings,
  stepIndex: initialIndex,
  transactionRule: {},
};

export const useEditTransactionRuleReducer = (initialProps: {
  transactionRule: WizardState['transactionRule'];
}) => {
  const [{ step, transactionRule }, dispatch] = useReducer(
    editTransactionRuleReducer,
    {
      ...initialState,
      ...initialProps,
    }
  );

  const goToGeneralSettingsStep = useCallback(
    () =>
      dispatch({
        type: WizardActionType.GoToStep,
        payload: EditTransactionRuleStep.EditGeneralSettings,
      }),
    []
  );

  const goToSelectorsStep = useCallback(
    () =>
      dispatch({
        type: WizardActionType.GoToStep,
        payload: EditTransactionRuleStep.EditTransactionSelectors,
      }),
    []
  );

  const goToModifiersStep = useCallback(
    () =>
      dispatch({
        type: WizardActionType.GoToStep,
        payload: EditTransactionRuleStep.EditTransactionModifiers,
      }),
    []
  );

  const goToVisualizationStep = useCallback(
    () =>
      dispatch({
        type: WizardActionType.GoToStep,
        payload: EditTransactionRuleStep.EditResponseVisualization,
      }),
    []
  );

  return {
    step,
    transactionRule,
    goToGeneralSettingsStep,
    goToSelectorsStep,
    goToModifiersStep,
    goToVisualizationStep,
  };
};
